import { createBrowserRouter, Navigate, Outlet, ScrollRestoration } from "react-router";
import { RouteError } from "@shared/client/route-error";
import { Guard } from "@shared/client/session";
import AdminLayout from "./pages/admin-layout";
import LoginPage from "./pages/auth/login";
import DashboardPage from "./pages/dashboard";
import AgentsPage from "./pages/agents";
import AgentPage from "./pages/agent";
import AnalyticsPage from "./pages/analytics";
import BillingPage from "./pages/billing";
import ClientsPage from "./pages/clients";
import ClientPage from "./pages/client";
import LogsPage from "./pages/logs";
import MarketingPage from "./pages/marketing";
import ProspectionPage from "./pages/prospection";
import ProspectionLayout from "./pages/prospection-layout";
import ProspectionMailboxesPage from "./pages/prospection-mailboxes";
import ProspectionOutboxPage from "./pages/prospection-outbox";
import ProspectionRepliesPage from "./pages/prospection-replies";
import ProspectionSettingsPage from "./pages/prospection-settings";
import ProspectPage from "./pages/prospect";
import SettingsPage from "./pages/settings";
import SourcesPage from "./pages/sources";
import UsersPage from "./pages/users";
import { adminRule } from "./rules";

function Root() {
  return (
    <>
      <Outlet />
      <ScrollRestoration />
    </>
  );
}

export const router = createBrowserRouter([
  {
    element: <Root />,
    errorElement: <RouteError />,
    children: [
      { path: "/", element: <Navigate replace to="/admin" /> },
      { path: "/auth/login", element: <LoginPage /> },
      {
        path: "/admin",
        element: <Guard rule={adminRule}><AdminLayout /></Guard>,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: "agents", element: <AgentsPage /> },
          { path: "agents/:id", element: <AgentPage /> },
          { path: "analytics", element: <AnalyticsPage /> },
          { path: "billing", element: <BillingPage /> },
          { path: "clients", element: <ClientsPage /> },
          { path: "clients/:id", element: <ClientPage /> },
          { path: "logs", element: <LogsPage /> },
          { path: "marketing", element: <MarketingPage /> },
          {
            path: "prospection",
            element: <ProspectionLayout />,
            children: [
              { index: true, element: <ProspectionPage /> },
              { path: "envois", element: <ProspectionOutboxPage /> },
              { path: "reponses", element: <ProspectionRepliesPage /> },
              { path: "boites", element: <ProspectionMailboxesPage /> },
              { path: "reglages", element: <ProspectionSettingsPage /> },
              { path: ":id", element: <ProspectPage /> },
            ],
          },
          { path: "settings", element: <SettingsPage /> },
          { path: "sources", element: <SourcesPage /> },
          { path: "users", element: <UsersPage /> },
        ],
      },
      { path: "*", element: <Navigate replace to="/admin" /> },
    ],
  },
]);
